import { render, staticRenderFns } from "./ProUpsell.vue?vue&type=template&id=7e7d1f0a&lang=html&"
import script from "./ProUpsell.vue?vue&type=script&lang=js&"
export * from "./ProUpsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports